import { FormControl } from '@angular/forms';
import { EPersonPhoneType, ERegistrationType } from './person.enum';

export interface IPerson {
  PersonId?: string;
  TenantId?: string;
  AbstractedTenantId?: string;
  FriendlyCode: string;
  IsOwner: boolean;
  IsActive: boolean;
  FirstName: string;
  LastName: string;
  FullName: string;
  DisplayName: string;
  FriendlyName: string;
  LegalBusinessName: string;
  TradeName: string;
  Email: string;
  Registration?: string;
  PersonType: number;
  GenderType: number;
  IdentityDocument: string;
  IdentityDocumentComplement: string;
  FiscalIdentity: string;
  Birthdate: string;
  Tags: string;
  RegistrationType: number;
  AbstractedRegistrationType: number;
  GroupId: string;
  CellPhone: string;
  WhatsApp: string;
  Age: number;
  CallCode: string;
  RoleId?: string;
}

export interface IPersonDataAsync {
  PersonId: string;
  FirstName: string;
  LastName: string;
  Email: string;
  TenantId: string;
  IsActive: boolean;
  IsOwner: boolean;
  FriendlyCode: string;
  ReceivesPix: boolean;
  GympassId: string;
  PagueLaId: string;
  RegistrationType: ERegistrationType;
  CallCode: string;
  DisplayName: string;
  BankSlipEnabled: boolean;
}

export interface IPersonFormGroup {
  PersonId?: FormControl<string>;
  TenantId?: FormControl<string>;
  AbstractedTenantId?: FormControl<string>;
  FriendlyCode?: FormControl<string>;
  IsOwner?: FormControl<boolean>;
  IsActive?: FormControl<boolean>;
  FirstName?: FormControl<string>;
  LastName?: FormControl<string>;
  FullName?: FormControl<string>;
  DisplayName?: FormControl<string>;
  FriendlyName?: FormControl<string>;
  LegalBusinessName?: FormControl<string>;
  TradeName?: FormControl<string>;
  Email?: FormControl<string>;
  Registration?: FormControl<string>;
  PersonType?: FormControl<number>;
  GenderType?: FormControl<number>;
  IdentityDocument?: FormControl<string>;
  IdentityDocumentComplement?: FormControl<string>;
  FiscalIdentity?: FormControl<string>;
  Birthdate?: FormControl<string>;
  Tags?: FormControl<string>;
  RegistrationType?: FormControl<string>;
  AbstractedRegistrationType?: FormControl<string>;
  GroupId?: FormControl<string>;
  RoleId?: FormControl<string>;
  AccessPin?: FormControl<number>;
  AccessMessage?: FormControl<string>;
  Phones?: FormControl<any>;
  Addresses?: FormControl<any>;
}

export enum EGenderType {
  Others = 0,
  Male,
  Female,
}

export interface IPersonPhone {
  PersonId?: string;
  TenantId?: string;
  PhoneId?: string;
  Type: EPersonPhoneType;
  Number: string;
  CountryCode: number;
  Confirmed: boolean;
  Comment: string;
  IsMain: boolean;
  Operation: number;
}

export class PersonPhone implements IPersonPhone {
  public Type: EPersonPhoneType = null;
  public Number: string = null;
  public CountryCode = 55;
  public Confirmed: boolean = null;
  public Comment: string = null;
  public IsMain: boolean = null;
  public Operation: number = null;

  constructor(personPhone?: Partial<IPersonPhone>) {
    Object.assign(this, personPhone);
  }
}


/** Response from Person/GetOwnerInfo */
export interface IGetOwnerInfoResponse {
  PersonId: string;
  TenantId?: string;
  FullDisplayName?: string | null;
  Email?: string | null;
  IdentityDocument?: string | null;
  CompanyIdentityDocument?: string | null;
  Phones?: unknown[];
  Operation?: string | null;
  ValidationResult?: { IsValid?: boolean; Errors?: unknown[] };
  IsValid?: boolean;
}

export enum EPersonWithIncludes  {
  Access = 0,
  Addresses,
  TargetComments,
  Integration,
  Phones,
  Preference,
  Responsible,
  Taxes,
  EventConsolidated,
  FinancialConsolidated,
  HealthConsolidated,
  HistoryConsolidated,
  PhoneConsolidated,
  SubscriptionConsolidated,
  TechInfoConsolidated,
  UserConsolidated,
  Ties
}
